import "./App.css";
import Router from "./components/Router";

function App() {
  return (
    <div>
      <Router />
    </div>
  );
}

export default App;
